<template>

  <div>
    <el-radio-group v-model="timeRangeIndex" size="small" @change="changeRange" fill="#66b1ff">
      <el-radio label="all">全部</el-radio>
      <el-radio v-for="(timeRange, index) in timeRanges" :label="index">
        {{timeRange.startTime}}-{{timeRange.endTime}}
      </el-radio>
    </el-radio-group>

    <el-slider v-model='plusSecond' show-stops :step='1' :max="duration" :min='0' @change="timeChange"></el-slider>

    <el-date-picker
      v-model="date"
      @change="dateChange"
      type="date"
      format="yyyy-MM-dd"
      value-format="yyyy-MM-dd"
      placeholder="选择日期">
    </el-date-picker>

    <el-label>{{locationDateTime}}</el-label>

    <!--高德地图-->
    <el-amap
      ref="map"
      vid="amapDemo"
      :amap-manager="amapManager"
      :events="mapEvents"
      :center="center"
      :mapStyle="mapStyle"
      expandZoomRange="true"
      :zoom="zoom"
      :plugin="plugins"
      :pitch="66"
      style="height: 600px;">
      <el-amap-marker v-if="showMarker" :position="center" :icon="icon"></el-amap-marker>
      <el-amap-polyline v-for="polyLine in showPolyLines" :path="polyLine" outlineColor='#fff000'></el-amap-polyline>
    </el-amap>

  </div>

</template>

<script>
import {carApi} from '../../api/index';
import {HttpResp} from '../../constant/index';
//高德地图
import VueAMap from 'vue-amap';

Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  //申请地址 https://lbs.amap.com/ 选择web端jsAPI
  key: 'e628cc848cd57dad04712b8088ec4b2d',
  // 插件集合，用到什么插件就使用什么插件
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  v: '2.0', // 高德sdk版本，最新的sdk已经出到了2.0
  //官网解释：JSAPI 2.0 提供的开发接口与 1.4 版本达到 99%的兼容度，但是为了保证插件的稳定性我们还是选择1.4.4。
  uiVersion: '1.1',
})

export default {
  name: 'carTrack',
  data() {
    return {
      zoom: 11,
      locationDateTime: null,
      startTime: null,
      duration: 0,
      showMarker: false,
      center: [113.366020, 23.111055],
      date: "",
      plusSecond: 0,
      mapStyle: 'amap://styles/076ea1d8f66ea8e78f7ed5480a12016e', //引入样式
      showPolyLines: [],
      polyLines: [
        // [
        //   [113.360400, 23.113460],
        //   [113.361500, 23.110560],
        //   [113.371500, 23.160560]
        // ],
        // [
        //   [113.380400, 23.113460],
        //   [113.381500, 23.110560],
        //   [113.381500, 23.160560]
        // ]
      ],
      timeRanges: [],
      timeRangeIndex: 'all',
      plugins: [
        {
          //地图工具条
          pName: "ToolBar",
          init(o) {},
        },
        {
          //左下角缩略图插件 比例尺
          pName: "Scale",
          init(o) {},
        },
      ],
    }
  },
  mounted: function () {},
  computed: {

  },
  methods: {
    dateChange: function () {
      let param = {
        date: this.date
      };
      carApi.groupByWithDate(param).then(data => {
        if(data.code === HttpResp.SUCCUSS) {
          if (data.data.centerPoint) {
            this.showMarker = true;
            this.center = [data.data.centerPoint.longitude, data.data.centerPoint.latitude];
          } else {
            this.showMarker = false;
          }
          this.polyLines = data.data.adminPoints;
          this.showPolyLines = this.polyLines;
          this.timeRanges = data.data.timeRanges;
        }else{
          this.$message({
            type: 'error',
            message: data.message
          });
        }
      });
    },
    timeChange: function () {
      let param = {
        date: this.date,
        startTime: this.startTime,
        plusSecond: this.plusSecond
      };
      carApi.getPointByDatetime(param).then(data => {
        if(data.code === HttpResp.SUCCUSS) {
          this.center = [data.data.longitude, data.data.latitude];
          this.locationDateTime = data.data.dateTime;
        }else{
          this.$message({
            type: 'error',
            message: data.message
          });
        }
      });
    },
    changeRange: function () {
      // 全部展示或单独展示一段行程
      if (this.timeRangeIndex === 'all') {
        this.showPolyLines = this.polyLines;
      } else {
        this.showPolyLines = [this.polyLines[this.timeRangeIndex]];
        this.startTime = this.timeRanges[this.timeRangeIndex].startTime;
        this.duration = this.timeRanges[this.timeRangeIndex].duration;
      }
    },
  }

}
</script>



// WEBPACK FOOTER //
// src/components/car/CarTrack.vue